import { BASE_URL } from '../services/ApiService/ApiConfig';
import { tokenActual } from './sesionCliente';

const RAIZ = `${BASE_URL}/seguridad/admin`;

async function pedir(ruta, opciones = {}) {
    const res = await fetch(`${RAIZ}${ruta}`, {
        ...opciones,
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${tokenActual()}` }
    });
    const datos = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(datos.mensaje || `Error ${res.status}`);
    return datos;
}

export const seguridadApi = {
    tablero: () => pedir('/tablero'),
    usuarios: () => pedir('/usuarios'),
    usuario: (id) => pedir(`/usuarios/${id}`),
    cerrarSesion: (sid) => pedir(`/sesiones/${sid}/cerrar`, { method: 'POST' }),
    bloquear: (id, minutos) => pedir(`/usuarios/${id}/bloquear`, { method: 'POST', body: JSON.stringify(minutos ? { minutos } : {}) }),
    desbloquear: (id) => pedir(`/usuarios/${id}/desbloquear`, { method: 'POST' }),
    cerrarSesiones: (id) => pedir(`/usuarios/${id}/cerrar-sesiones`, { method: 'POST' }),
    reiniciarSegundoFactor: (id) => pedir(`/usuarios/${id}/segundo-factor/reiniciar`, { method: 'POST' }),
    politicas: () => pedir('/politicas'),
    guardarRol: (rolId, cuerpo) => pedir(`/politicas/roles/${rolId}`, { method: 'PUT', body: JSON.stringify(cuerpo) }),
    guardarUsuario: (id, cuerpo) => pedir(`/politicas/usuarios/${id}`, { method: 'PUT', body: JSON.stringify(cuerpo) }),
    interruptor: (codigo, cuerpo) => pedir(`/interruptores/${codigo}`, { method: 'PUT', body: JSON.stringify(cuerpo) }),
    bitacora: (filtros) => pedir(`/bitacora?${new URLSearchParams(Object.entries(filtros).filter(([, v]) => v !== '' && v != null))}`),
    verificarBitacora: () => pedir('/bitacora/verificar'),
    ipSedes: () => pedir('/ip-sedes'),
    guardarIpSede: (ip, cuerpo) => pedir(`/ip-sedes/${encodeURIComponent(ip)}`, { method: 'PUT', body: JSON.stringify(cuerpo) }),
    borrarIpSede: (ip) => pedir(`/ip-sedes/${encodeURIComponent(ip)}`, { method: 'DELETE' })
};

export const fechaHora = (v) => (v ? new Date(v).toLocaleString('es-EC', { dateStyle: 'short', timeStyle: 'medium' }) : '');

export const navegador = (ua) => {
    if (!ua) return '—';
    if (ua.includes('Dart') || ua.includes('okhttp')) return 'App movil';
    if (ua.includes('Edg/')) return 'Edge';
    if (ua.includes('Chrome/')) return 'Chrome';
    if (ua.includes('Firefox/')) return 'Firefox';
    if (ua.includes('Safari/')) return 'Safari';
    return ua.substring(0, 24);
};

/** Nombre legible de cada tipo de evento de la bitacora. */
export const TIPOS = {
    LOGIN_OK: 'Ingreso',
    LOGIN_CLAVE_OK: 'Clave correcta (falta codigo)',
    LOGIN_FALLIDO: 'Ingreso fallido',
    LOGIN_BLOQUEADO: 'Intento con usuario bloqueado',
    LOGIN_FUERA_GEOCERCA: 'Ingreso fuera de la zona',
    LOGIN_SIN_SEGUNDO_FACTOR: 'Sin segundo factor activado',
    BLOQUEO: 'Bloqueo',
    DESBLOQUEO: 'Desbloqueo',
    LOGOUT: 'Salida',
    SEGUNDO_FACTOR_ACTIVADO: 'Segundo factor activado',
    SEGUNDO_FACTOR_FALLIDO: 'Codigo incorrecto',
    SEGUNDO_FACTOR_REINICIADO: 'Segundo factor reiniciado',
    CODIGO_RECUPERACION_USADO: 'Codigo de recuperacion usado',
    CONTRASENA_CIFRADA: 'Contrasena cifrada',
    SESION_REVOCADA: 'Sesion cerrada por el administrador',
    SESION_SUSPENDIDA: 'Sesion suspendida (fuera de la zona)',
    SESION_REACTIVADA: 'Sesion reanudada',
    RENOVACION_REUTILIZADA: 'Token copiado: sesion cerrada',
    ACCESO_DENEGADO: 'Acceso denegado',
    ACCESO_FUERA_DE_PERMISO: 'Fuera de permiso (auditoria)',
    RUTA_SIN_MAPA: 'Ruta sin mapa de permisos',
    POLITICA_ROL: 'Politica de rol',
    POLITICA_USUARIO: 'Politica de usuario',
    INTERRUPTOR: 'Interruptor cambiado'
};

export const severidad = (resultado) =>
    ({ OK: 'success', FALLO: 'warning', DENEGADO: 'danger', INFO: 'info' }[resultado] || 'info');
